module.exports = global.config = {
    stock_site_link: process.env.REACT_APP_STOCK_SITE_LINK,
    service_site_link: process.env.REACT_APP_SERVICES_SITE_LINK,
    webhook_main: process.env.REACT_APP_WEBHOOK_MAIN,
    webhook_contact: process.env.REACT_APP_WEBHOOK_CONTACT,
    recaptcha_site_key: process.env.REACT_APP_RECAPTCHA_SITE_KEY
};